module.exports = __webpack_public_path__ + "img/chest-of-drawers.11498013.svg";